import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

/**
 * 최상위 Error Boundary(rootRender)의 fallback UI.
 * React 19는 경계가 없으면 render 에러 시 root를 언마운트(흰 화면)하므로,
 * 전체 blank 대신 최소 안내 + 새로고침을 제공한다. i18n/ThemeProvider 컨텍스트
 * 안(Localization 하위)에서 렌더되므로 useTranslation 사용이 안전하다.
 */
export default function RootErrorFallback() {
  const { t } = useTranslation()

  return (
    <div className={styles.container} role="alert">
      <div className={styles.card}>
        <h1 className={styles.title}>{t('appError.title')}</h1>
        <p className={styles.desc}>{t('appError.desc')}</p>
        <button type="button" className={styles.retry} onClick={() => window.location.reload()}>
          {t('appError.retry')}
        </button>
      </div>
    </div>
  )
}
